import { createEvent } from "library/local-events/index.mjs"

export const RegisterMappingUpdated = createEvent("RegisterMappingUpdated")
export const RegisterRefiningUpdated = createEvent("RegisterRefiningUpdated")
